// extracted by mini-css-extract-plugin
export default {"productChange":"ProductChangeHistoryView_productChange__9Q6cU","close":"ProductChangeHistoryView_close__faoOZ"};